import { InjectionToken } from '@angular/core';

/** Un resultado suelto de la búsqueda. */
export interface Resultado {
  /** Lo que se lee primero: la identificación, el nombre. */
  titulo: string;
  /** La segunda línea: dirección, DevEUI, a qué pertenece. */
  detalle?: string;
  /** A dónde lleva. */
  ruta: (string | number)[];
  queryParams?: Record<string, string>;
}

/** Los resultados de un tipo de cosa, con su nombre y su ícono. */
export interface GrupoResultados {
  clave: string;
  etiqueta: string;
  icono: string;
  resultados: Resultado[];
  /**
   * La consulta de este grupo falló.
   *
   * Se informa en vez de esconderse: un grupo vacío por un 403 se ve igual que
   * uno vacío porque no hay nada, y eso hace que alguien busque algo que sí
   * existe y concluya que no está.
   */
  fallo?: boolean;
  /**
   * El listado de ese tipo con la búsqueda puesta. Sólo llega cuando se llenó
   * el tope por tipo: puede haber más de lo que se muestra.
   */
  verTodos?: Pick<Resultado, 'ruta' | 'queryParams'>;
}

/** Un tipo que se puede buscar, para la ayuda del buscador vacío. */
export interface TipoBuscable {
  clave: string;
  etiqueta: string;
  icono: string;
  /** «por nombre, DevEUI o dirección». */
  campos: string;
}

/**
 * Qué sabe buscar la aplicación.
 *
 * **Por qué un token y no una consulta en el shell.** El buscador vive en el
 * encabezado, que es `ui/`, y buscar significa preguntarle a luminarias, nodos,
 * clientes, catálogos…: entidades de negocio que `ui/` no puede
 * conocer por la regla de capas. Mismo arreglo que el badge del menú: el token
 * en `core/`, la implementación en `compartido/` y el cable en `app.config.ts`.
 */
export interface BuscadorGlobal {
  /** Con `señal`, abortarla corta las consultas en curso. */
  buscar(texto: string, señal?: AbortSignal): Promise<GrupoResultados[]>;
  /**
   * Qué puede buscar el operador actual, y por qué campos. Sale de la misma
   * definición que `buscar` y con los mismos permisos.
   */
  buscables(): TipoBuscable[];
}

export const BUSCADOR_GLOBAL = new InjectionToken<BuscadorGlobal | undefined>('buscador global', {
  factory: () => undefined,
});

/** Debajo de esto no se busca: dos letras traen medio parque. */
export const MINIMO_BUSQUEDA = 3;
